import { Box, Flex } from "@chakra-ui/react";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import useManutencaoColumns from "./hooks/useManutencaoColumns";
import { PaginateResult } from "core/resources/types/shared";
import { ManutencaoDto } from "features/manutencao/typings/index";
import { FiltroManutencao } from "./hooks/useFiltroManutencao";
import colors from "core/resources/theme/colors";
import OutlineButton from "components/Button/OutlineButton";
import { IoMdTrash } from "react-icons/io";
import { MdOutlineHistory } from "react-icons/md";
import { VscFile } from "react-icons/vsc";
import useDeleteManutencoes from "features/manutencao/hooks/useDeleteManutencoes";
import { useLoading } from "components/GlobalLoading/index";
import { BiEdit } from "react-icons/bi";
import { useRegrasTenant } from "core/features/tenants/tenants.context";

interface ListagemManutencaoTableProps {
  data: PaginateResult<ManutencaoDto> | undefined;
  filtro: FiltroManutencao;
  onChangeFiltro: (filtro: Partial<FiltroManutencao>) => any;
  onChangeView?: () => any;
  isLoading: boolean;
  setIdManutencaoHistorico: (id: string) => any;
  refetch: any;
  setIdManutencaoEditar: (id: string) => any;
  setManutencaoDto: (item: ManutencaoDto | undefined) => any;
}

export default function ListagemManutencaoTable({
  data,
  filtro,
  onChangeFiltro,
  isLoading,
  refetch,
  onChangeView,
  setIdManutencaoHistorico,
  setIdManutencaoEditar,
  setManutencaoDto,
}: ListagemManutencaoTableProps) {
  const { useSubtenantsViews } = useRegrasTenant();
  const columns = useManutencaoColumns({ useSubtenantsViews });
  const { mutate: excluirManutencao, isLoading: isLoadingExcluir } =
    useDeleteManutencoes();

  useLoading(isLoadingExcluir);

  return (
    <Box>
      <NewTable
        title={() => (
          <HeaderTable
            value={filtro.search || ""}
            onSearch={(v) => onChangeFiltro({ search: v })}
            childrenFlex={6}
          >
            {!useSubtenantsViews ? (
              <Flex gap={4}>
                <OutlineButton
                  color={colors.primary}
                  bg="none"
                  onClick={onChangeView}
                  gap={2}
                >
                  Lista
                </OutlineButton>
                <OutlineButton
                  color={colors.gray}
                  border={`solid 1px ${colors.gray}`}
                  bg="none"
                  onClick={onChangeView}
                  gap={2}
                >
                  Mês
                </OutlineButton>
              </Flex>
            ) : null}
          </HeaderTable>
        )}
        columns={columns}
        dataSource={data?.items || []}
        loading={isLoading}
        rowKey={(item) => `${item.id}-${item.data}`}
        onRow={(v) => ({
          onClick: () => setManutencaoDto(v),
          style: {
            cursor: "pointer",
          },
        })}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => onChangeFiltro?.({ page: p }),
        }}
        actions={[
          {
            title: "Realizar manutenção",
            icon: () => <VscFile size={20} />,
            onClick: (v) => {
              setManutencaoDto(v);
            },
          },
          {
            title: "Editar",
            icon: () => <BiEdit size={20} />,
            onClick: (v) => setIdManutencaoEditar(v.id),
          },

          {
            title: "Histórico",
            icon: () => <MdOutlineHistory size={20} />,
            onClick: (v) => setIdManutencaoHistorico(v.id),
          },
          {
            title: "Excluir",
            icon: () => <IoMdTrash size={20} />,
            onClick: (v) =>
              excluirManutencao(v.id, {
                onSuccess: () => refetch(),
              }),
          },
        ]}
      />
    </Box>
  );
}
